<template>
  <q-page padding>
    <PageHeader
      title="Retirada de Itens"
      :backRoute="{ name: 'home' }"
      backBehavior="route"
    />
    <div
      class="row col-12 row-input-container text-weight-bold text-brand-5 q-mt-md q-gutter-sm"
    >
      <div class="col-md col-xs-4">
        <div class="text-brand-5 text-weight-bold q-mb-xs">Unidade</div>
        <lista-unidades-select></lista-unidades-select>
      </div>

      <div v-if="temPermissaoCracha()" class="col-md col-xs-4">
        <div class="text-brand-5 text-weight-bold q-mb-xs">
          Crachá Solicitante
        </div>
        <SelecaoFuncionario
          class="input-new-design"
          dense
          outlined
          v-model="crachaSolicitante"
          @emitirFuncionario="receberFuncionarioPorCracha"
          :resetar="resetar"
          debounce="500"
          :buscarPorCracha="true"
        />
      </div>

      <div class="col-md col-xs-4">
        <div class="text-brand-5 text-weight-bold q-mb-xs">
          Nome do Requisitante
        </div>
        <SelectComponentResponsaveis
          @emitirFuncionario="receberDadosFuncionario"
          :resetar="resetar"
        />
      </div>

      <div class="col-md col-xs-3">
        <div class="text-brand-5 text-weight-bold q-mb-xs">Patrimônio</div>
        <q-input dense outlined v-model="filtro.patrimonio" />
      </div>

      <div class="col-md col-xs-3">
        <SelectComponentGrupos
          @emitirGrupo="receberDadosGrupo"
          :subGrupoCategoriaUuid="subGrupo.categoria_uuid"
          :hint="'Digite para filtrar'"
          :resetar="resetar"
        />
      </div>

      <div class="col-md col-xs-3">
        <SelectComponentSubGrupos
          @emitirSubGrupo="receberDadosSubGrupo"
          :categoriaUuid="grupo.uuid"
          :hint="'Digite para filtrar'"
        />
      </div>

      <div class="col-md col-xs-3">
        <q-btn
          :icon="todasUnidades ? 'close' : 'check_circle_outline'"
          :color="!todasUnidades ? 'secondary' : 'negative'"
          label="Todas Unidades"
          style="margin-top: 23px"
          no-caps
          :disable="disable"
          @click="todasUnidades = !todasUnidades"
        />
      </div>
    </div>
    <div class="row col-12 q-mt-md">
      <div class="col-md-12 col-sm-12 col-xs-12 q-mt-md">
        <p class="text-brand-5 text-weight-bold">
          Selecione os Itens que deseja retirar:
        </p>
        <q-table
          :loading="loading"
          class="my-sticky-dynamic"
          :rows="listaFerramentasDisponiveis"
          :columns="columns"
          :rows-per-page-options="[0]"
          hide-pagination
          dense
          row-key="uuid"
          :filter="filter"
          table-header-class="bg-accent text-width-bold"
          flat
          selection="multiple"
          :no-data-label="semDados ? 'Itens não encontrados' : ''"
          :hide-bottom="hideBottom"
          v-model:selected="selected"
        >
          <template v-slot:header="props">
            <q-tr :props="props">
              <q-th v-for="col in props.cols" :key="col.name" :props="props">
                {{ col.label }}
              </q-th>
            </q-tr>
          </template>
          <template v-slot:body="props">
            <q-tr>
              <q-td>
                <div class="row col-12 justify-center">
                  <q-btn
                    :text-color="props.selected ? 'black' : ''"
                    :color="props.selected ? 'accent' : 'primary'"
                    no-caps
                    round
                    dense
                    @click="
                      (props.selected = !props.selected),
                        verificarDocumentosAssociados(props.row.uuid)
                    "
                    :disable="autenticacao"
                    :icon="
                      props.selected
                        ? 'check_circle_outline'
                        : 'add_circle_outline'
                    "
                  />
                </div>
              </q-td>
              <q-td>
                {{ props.row.nome }}
              </q-td>
              <q-td>
                {{ props.row.descricao }}
              </q-td>
              <q-td>
                {{ props.row.patrimonio }}
              </q-td>
              <q-td>
                {{ props.row.nome_unidade }}
              </q-td>
              <q-td>
                {{ props.row.categoria_nome }}
              </q-td>
              <q-td>
                {{ props.row.grupo_ferramenta_nome }}
              </q-td>
              <q-td>
                <div
                  :style="
                    props.row.status == 'disponivel'
                      ? 'width: fit-content; background: #e8ffec; padding: 2px 5px;'
                      : props.row.status == 'manutencao_garantia'
                      ? 'width: fit-content; background: #e6e6e6; padding: 2px 5px;'
                      : props.row.status == 'uso'
                      ? 'width: fit-content; background: #fefed1; padding: 2px 5px;'
                      : props.row.status == 'manutencao'
                      ? 'width: fit-content; background: #ffe9e9; padding: 2px 5px;'
                      : props.row.status == 'em_transito'
                      ? 'width: fit-content; background:  #f8f8f8; padding: 2px 5px;'
                      : props.row.status == 'removida'
                      ? 'width: fit-content; background:  #9BA4B5; padding: 2px 5px;'
                      : props.row.status == 'retorno_em_garantia'
                      ? 'width: fit-content; background:  #9BA4B5; padding: 2px 5px;'
                      : props.row.status == 'desmobilizada'
                      ? 'width: fit-content; background:  #EDBC5A; padding: 2px 5px;'
                      : props.row.status == 'reativacao'
                      ? 'width: fit-content; background:  #5178FF; padding: 2px 5px;'
                      : props.row.status == 'descartada'
                      ? 'width: fit-content; background:  #EBEEFE; padding: 2px 5px;'
                      : props.row.status == 'sucata'
                      ? 'width: fit-content; background:  #F3E8E0; padding: 2px 5px;'
                      : props.row.status == 'furto'
                      ? 'width: fit-content; background:  #AB1D22; padding: 2px 5px;'
                      : props.row.status == 'aguardando_reparo'
                      ? 'width: fit-content; background:  #EDBC5A; padding: 2px 5px;'
                      : ''
                  "
                  class="row col-12 no-wrap align items-center"
                >
                  <span
                    v-if="props.row.status == 'disponivel'"
                    class="elipse q-mr-sm bg-positive"
                  ></span>
                  <span
                    v-if="props.row.status == 'uso'"
                    class="elipse q-mr-sm bg-warning"
                  ></span>
                  <span
                    v-if="props.row.status == 'manutencao_garantia'"
                    class="elipse q-mr-sm"
                    style="background: #424242"
                  ></span>
                  <span
                    v-if="props.row.status == 'manutencao'"
                    class="elipse q-mr-sm bg-red"
                  ></span>
                  <span
                    v-if="props.row.status == 'em_transito'"
                    class="elipse q-mr-sm"
                    style="background: #2d3e6e"
                  ></span>
                  <span
                    v-if="props.row.status == 'removida'"
                    class="elipse q-mr-sm"
                    style="background: #383737"
                  ></span>
                  <span
                    v-if="props.row.status == 'retorno_em_garantia'"
                    class="elipse q-mr-sm"
                    style="background: #383737"
                  ></span>
                  <span
                    v-if="props.row.status == 'desmobilizada'"
                    class="elipse q-mr-sm"
                    style="background: #fa9726"
                  ></span>
                  <span
                    v-if="props.row.status == 'reativacao'"
                    class="elipse q-mr-sm"
                    style="background: #473fe8"
                  ></span>
                  <span
                    v-if="props.row.status == 'descartada'"
                    class="elipse q-mr-sm"
                    style="background: #b0cde8"
                  ></span>
                  <span
                    v-if="props.row.status == 'sucata'"
                    class="elipse q-mr-sm"
                    style="background: #736d6a"
                  ></span>
                  <span
                    v-if="props.row.status == 'furto'"
                    class="elipse q-mr-sm"
                    style="background: #6b1215"
                  ></span>
                  <span
                    v-if="props.row.status == 'aguardando_reparo'"
                    class="elipse q-mr-sm"
                    style="background: #fa9726"
                  ></span>
                  <div
                    v-if="props.row.status == 'disponivel'"
                    style="width: fit-content; background: #e8ffec"
                    class="text-brand-5 text-bold"
                  >
                    {{ "Disponível" }}
                  </div>
                  <div
                    v-if="props.row.status == 'uso'"
                    style="width: fit-content; background: #fefed1"
                    class="text-brand-5 text-bold"
                  >
                    {{ "Em Uso" }}
                  </div>
                  <div
                    v-if="props.row.status == 'manutencao_garantia'"
                    style="width: fit-content"
                    class="text-brand-5 text-bold"
                  >
                    {{ "Manutenção Garantia" }}
                  </div>
                  <div
                    v-if="props.row.status == 'manutencao'"
                    style="width: fit-content"
                    class="text-red text-bold"
                  >
                    {{ "Manutenção" }}
                  </div>
                  <div
                    v-if="props.row.status == 'em_transito'"
                    style="width: fit-content; color: #192957"
                    class="text-bold"
                  >
                    {{ "Em Trânsito" }}
                  </div>
                  <div
                    v-if="props.row.status == 'removida'"
                    style="width: fit-content"
                    class="text-bold"
                  >
                    {{ "Removida" }}
                  </div>
                  <div
                    v-if="props.row.status == 'retorno_em_garantia'"
                    style="width: fit-content"
                    class="text-bold"
                  >
                    {{ "Retorno Em Garantia" }}
                  </div>
                  <div
                    v-if="props.row.status == 'desmobilizada'"
                    style="width: fit-content"
                    class="text-bold"
                  >
                    {{ "Desmobilizada" }}
                  </div>
                  <div
                    v-if="props.row.status == 'reativacao'"
                    style="width: fit-content"
                    class="text-bold"
                  >
                    {{ "Reativação" }}
                  </div>
                  <div
                    v-if="props.row.status == 'descartada'"
                    style="width: fit-content"
                    class="text-bold"
                  >
                    {{ "Descartada" }}
                  </div>
                  <div
                    v-if="props.row.status == 'sucata'"
                    style="width: fit-content"
                    class="text-bold"
                  >
                    {{ "Sucata" }}
                  </div>
                  <div
                    v-if="props.row.status == 'furto'"
                    style="width: fit-content"
                    class="text-bold"
                  >
                    {{ "Furto" }}
                  </div>
                  <div
                    v-if="props.row.status == 'aguardando_reparo'"
                    style="width: fit-content"
                    class="text-bold"
                  >
                    {{ "Aguardando Reparo" }}
                  </div>
                </div>
              </q-td>
            </q-tr>
          </template>
          <template v-slot:top-right>
            <q-input
              rounded
              outlined
              dense
              debounce="300"
              v-model="filter"
              placeholder="Pesquisar"
            >
              <template v-slot:append>
                <q-icon name="search"></q-icon>
              </template>
            </q-input>
          </template>
        </q-table>
        <div
          v-if="listaFerramentasDisponiveis.length > 0"
          class="row justify-start q-mt-md"
        >
          <q-pagination
            :disable="disable"
            v-model="pagination.page"
            color="brand-5"
            active-color="secondary"
            active-text-color="white"
            :max="pagesNumber"
            :max-pages="5"
            :boundary-numbers="false"
            :direction-links="true"
            size="sm"
          />
        </div>
      </div>
    </div>
    <div
      v-if="selected.length > 0"
      class="q-my-xl col-md-12 col-sm-12 col-xs-12"
    >
      <p class="text-brand-5 text-weight-bold">
        Itens selecionados para retirada
      </p>
      <q-table
        flat
        table-header-class="bg-accent text-width-bold"
        :rows="selected"
        :columns="columns2"
        dense
        row-key="uuid"
        :rows-per-page-options="[0]"
        hide-bottom
      >
        <template #body-cell-remover="props">
          <q-td>
            <q-btn
              flat
              style="color: red"
              icon="remove_circle_outline"
              :disable="autenticacao"
              @click="removerFerramenta(props.row.uuid)"
            />
          </q-td>
        </template>
        <template #body-cell-codigo="props">
          <q-td :props="props">
            <span>{{ props.row.nome }}</span>
          </q-td>
        </template>
        <template #body-cell-descricao="props">
          <q-td :props="props">
            <span>{{ props.row.descricao }}</span>
          </q-td>
        </template>
        <template #body-cell-patrimonio="props">
          <q-td :props="props">
            <span>{{ props.row.patrimonio }}</span>
          </q-td>
        </template>
        <template #body-cell-unidade="props">
          <q-td :props="props">
            <span>{{ props.row.nome_unidade }}</span>
          </q-td>
        </template>
        <template #body-cell-grupo="props">
          <q-td :props="props">
            <span>{{ props.row.grupo_ferramenta_nome }}</span>
          </q-td>
        </template>
        <template #body-cell-categoria="props">
          <q-td :props="props">
            <span>{{ props.row.categoria_nome }}</span>
          </q-td>
        </template>
        <template #body-cell-status="props">
          <q-td>
            <div
              :style="
                props.row.status == 'disponivel'
                  ? 'width: fit-content; background: #e8ffec; padding: 2px 5px;'
                  : props.row.status == 'manutencao_garantia'
                  ? 'width: fit-content; background: #e6e6e6; padding: 2px 5px;'
                  : props.row.status == 'uso'
                  ? 'width: fit-content; background: #fefed1; padding: 2px 5px;'
                  : props.row.status == 'manutencao'
                  ? 'width: fit-content; background: #ffe9e9; padding: 2px 5px;'
                  : props.row.status == 'em_transito'
                  ? 'width: fit-content; background:  #f8f8f8; padding: 2px 5px;'
                  : props.row.status == 'removida'
                  ? 'width: fit-content; background:  #9BA4B5; padding: 2px 5px;'
                  : props.row.status == 'retorno_em_garantia'
                  ? 'width: fit-content; background:  #9BA4B5; padding: 2px 5px;'
                  : props.row.status == 'desmobilizada'
                  ? 'width: fit-content; background:  #EDBC5A; padding: 2px 5px;'
                  : props.row.status == 'reativacao'
                  ? 'width: fit-content; background:  #5178FF; padding: 2px 5px;'
                  : props.row.status == 'descartada'
                  ? 'width: fit-content; background:  #EBEEFE; padding: 2px 5px;'
                  : props.row.status == 'sucata'
                  ? 'width: fit-content; background:  #F3E8E0; padding: 2px 5px;'
                  : props.row.status == 'furto'
                  ? 'width: fit-content; background:  #AB1D22; padding: 2px 5px;'
                  : ''
              "
              class="row col-12 no-wrap align items-center"
            >
              <span
                v-if="props.row.status == 'disponivel'"
                class="elipse q-mr-sm bg-positive"
              ></span>
              <span
                v-if="props.row.status == 'uso'"
                class="elipse q-mr-sm bg-warning"
              ></span>
              <span
                v-if="props.row.status == 'manutencao_garantia'"
                class="elipse q-mr-sm"
                style="background: #424242"
              ></span>
              <span
                v-if="props.row.status == 'manutencao'"
                class="elipse q-mr-sm bg-red"
              ></span>
              <span
                v-if="props.row.status == 'em_transito'"
                class="elipse q-mr-sm"
                style="background: #2d3e6e"
              ></span>
              <span
                v-if="props.row.status == 'removida'"
                class="elipse q-mr-sm"
                style="background: #383737"
              ></span>
              <span
                v-if="props.row.status == 'retorno_em_garantia'"
                class="elipse q-mr-sm"
                style="background: #383737"
              ></span>
              <span
                v-if="props.row.status == 'desmobilizada'"
                class="elipse q-mr-sm"
                style="background: #fa9726"
              ></span>
              <span
                v-if="props.row.status == 'reativacao'"
                class="elipse q-mr-sm"
                style="background: #473fe8"
              ></span>
              <span
                v-if="props.row.status == 'descartada'"
                class="elipse q-mr-sm"
                style="background: #b0cde8"
              ></span>
              <span
                v-if="props.row.status == 'sucata'"
                class="elipse q-mr-sm"
                style="background: #736d6a"
              ></span>
              <span
                v-if="props.row.status == 'furto'"
                class="elipse q-mr-sm"
                style="background: #6b1215"
              ></span>
              <div
                v-if="props.row.status == 'disponivel'"
                style="width: fit-content; background: #e8ffec"
                class="text-brand-5 text-bold"
              >
                {{ "Disponível" }}
              </div>
              <div
                v-if="props.row.status == 'uso'"
                style="width: fit-content; background: #fefed1"
                class="text-brand-5 text-bold"
              >
                {{ "Em Uso" }}
              </div>
              <div
                v-if="props.row.status == 'manutencao_garantia'"
                style="width: fit-content"
                class="text-brand-5 text-bold"
              >
                {{ "Manutenção Garantia" }}
              </div>
              <div
                v-if="props.row.status == 'manutencao'"
                style="width: fit-content"
                class="text-red text-bold"
              >
                {{ "Manutenção" }}
              </div>
              <div
                v-if="props.row.status == 'em_transito'"
                style="width: fit-content; color: #192957"
                class="text-bold"
              >
                {{ "Em Trânsito" }}
              </div>
              <div
                v-if="props.row.status == 'removida'"
                style="width: fit-content"
                class="text-bold"
              >
                {{ "Removida" }}
              </div>
              <div
                v-if="props.row.status == 'retorno_em_garantia'"
                style="width: fit-content"
                class="text-bold"
              >
                {{ "Retorno Em Garantia" }}
              </div>
              <div
                v-if="props.row.status == 'desmobilizada'"
                style="width: fit-content"
                class="text-bold"
              >
                {{ "Desmobilizada" }}
              </div>
              <div
                v-if="props.row.status == 'reativacao'"
                style="width: fit-content"
                class="text-bold"
              >
                {{ "Reativação" }}
              </div>
              <div
                v-if="props.row.status == 'descartada'"
                style="width: fit-content"
                class="text-bold"
              >
                {{ "Descartada" }}
              </div>
              <div
                v-if="props.row.status == 'sucata'"
                style="width: fit-content"
                class="text-bold"
              >
                {{ "Sucata" }}
              </div>
              <div
                v-if="props.row.status == 'sucata'"
                style="width: fit-content"
                class="text-bold"
              >
                {{ "Furto" }}
              </div>
            </div>
          </q-td>
        </template>
        <template #body-cell-documentosAssociados="props">
          <q-td :props="props">
            <router-link
              :to="{
                name: 'editar-ferramenta-vale',
                params: { uuid: props.row.uuid },
              }"
              target="_blank"
            >
              <span v-if="props.row.documentosAssociados?.length > 0"
                ><span v-if="props.row.vencidoAtivo" class="text-red text-bold">
                  {{ props.row.documentosAssociados?.length }}
                </span>
                <span v-else>
                  {{ props.row.documentosAssociados?.length }}
                </span>
                <q-tooltip>
                  <div
                    v-for="(documento, index) in props.row.documentosAssociados"
                    :key="index"
                  >
                    <div>
                      <span class="row col-12">{{ documento.nome }}</span>
                      <div
                        :style="
                          documento.status == 'valido'
                            ? 'width: fit-content; padding: 0px 5px'
                            : documento.status == 'vencido'
                            ? 'width: fit-content; padding: 0px 5px'
                            : documento.status == 'revalidado'
                            ? 'width: fit-content; padding: 0px 5px'
                            : documento.status == 'inativo'
                            ? 'width: fit-content; padding: 0px 5px'
                            : ''
                        "
                        class="row col-12 items-center"
                      >
                        <div
                          v-if="documento.status == 'valido'"
                          class="elipse-table q-mr-xs bg-positive"
                        ></div>
                        <div
                          v-if="documento.status == 'revalidado'"
                          class="elipse-table q-mr-xs bg-warning"
                        ></div>
                        <div
                          v-if="documento.status == 'vencido'"
                          class="elipse-table q-mr-xs"
                          style="background: red"
                        ></div>
                        <div
                          v-if="documento.status == 'inativo'"
                          class="elipse-table q-mr-xs"
                          style="background: #383737"
                        ></div>
                        <span
                          v-if="documento.status != 'inativo'"
                          class="row justify-center text-white"
                        >
                          {{
                            `${documento.status
                              ?.substring(0, 1)
                              .toUpperCase()}${documento.status?.substring(1)}`
                          }}
                        </span>
                        <span
                          v-if="documento.status == 'inativo'"
                          class="row text-white justify-center"
                        >
                          Obsoleto
                        </span>
                      </div>
                    </div>
                  </div>
                </q-tooltip>
              </span>
              <span class="text-black" v-else>0</span>
            </router-link>
          </q-td>
        </template>
      </q-table>
    </div>
    <div v-if="selected.length > 0" class="row col-12 q-mt-lg">
      <div v-if="autenticacao" class="row col-12">
        <p class="text-h6 text-brand-5 q-mb-md text-weight-bold">
          Tipo Autenticação
        </p>
        <div class="row col-12 q-ml-md container-autenticacao q-mb-lg">
          <q-radio
            v-if="!$store.state.autenticacao.cliente.includes('acciona')"
            v-model="filtro.tipoAutenticacao"
            label="Sem Autenticação"
            val="sem_autenticacao"
            size="lg"
          />
          <q-radio
            v-model="filtro.tipoAutenticacao"
            label="Biometria"
            val="biometria"
            size="lg"
          />
          <q-radio
            v-model="filtro.tipoAutenticacao"
            label="Facial"
            val="facial"
            size="lg"
            v-if="
              $store.state.autenticacao.usuarioLogado.permissoes.gmapi.roles.includes(
                'ferramentas-auth-facial'
              )
            "
          />
          <q-radio
            v-model="filtro.tipoAutenticacao"
            label="Assinatura"
            val="assinatura"
            size="lg"
          />
          <q-radio
            v-model="filtro.tipoAutenticacao"
            label="PIN"
            val="web_pin"
            size="lg"
          />
        </div>

        <div
          @click="facial = true"
          style="cursor: pointer"
          class="q-mt-md"
          v-if="filtro.tipoAutenticacao == 'facial'"
        >
          <VerificacaoFacial
            :userId="filtro.responsavelId"
            v-model="facial"
            @close="fecharFacial"
            @sendFace="receberFace"
          />
          <div class="relative-position" style="display: inline-block">
            <q-icon
              size="60px"
              class="q-mr-xs"
              name="face"
              :color="imagemBase64 == null ? 'negative' : 'positive'"
            />

            <q-icon
              :name="imagemBase64 == null ? 'cancel' : 'check_circle'"
              :style="{
                color: imagemBase64 == null ? '#C62828' : '#2E7D32',
              }"
              size="22px"
              class="absolute-bottom-right"
              style="bottom: 2px; right: -2px; z-index: 0"
            >
              <q-tooltip
                anchor="top middle"
                self="bottom middle"
                :class="
                  imagemBase64 == null
                    ? 'bg-gray text-white'
                    : 'bg-gray text-white'
                "
              >
                {{
                  imagemBase64 == null
                    ? "Face não capturada"
                    : "Face capturada com sucesso"
                }}
              </q-tooltip>
            </q-icon>
          </div>

          <span class="q-ml-sm text-bold text-brand-5" style="font-size: 16px"
            >Clique aqui para reconhecimento da face, após leitura, clique em
            CONFIRMAR FACE</span
          >
        </div>
        <div class="q-ml-lg" v-if="filtro.tipoAutenticacao === 'biometria'">
          <div v-if="filtro.biometry">
            <q-img
              v-if="usuarioVerificado"
              class="imagem-biometria"
              src="../../../assets/bioOK.png"
              @click="biometria = !biometria"
            />
            <q-img
              v-else
              class="imagem-biometria"
              src="../../../assets/bioRequest.png"
              @click="biometria = !biometria"
            />
            <span class="q-ml-sm text-bold text-brand-5" style="font-size: 16px"
              >Clique no icone da digital para reconhecimento da biometria, após
              leitura, clique em FINALIZAR RETIRADA</span
            >
            <BiometriaModal
              :modal="biometria"
              :userId="filtro.responsavelId"
              :titulo="'Verificação de Biometria'"
              :tipoBiometria="'verificacao'"
              @negativePrint="recebeBiometria"
              @resultadoVerificacao="receberResultadoBiometria"
            />
          </div>
          <div v-else>
            <q-img
              class="imagem-biometria"
              src="../../../assets/bioNO.png"
              @click="biometria = !biometria"
            />
            <span class="q-ml-sm text-bold text-brand-5" style="font-size: 14px"
              >O funcionário não possuiu biometria cadastrada, favor clicar no
              icone e realizar o procedimento de cadastro antes da finalização
              da requisição</span
            >
            <BiometriaModal
              :titulo="'Cadastro de Biometria'"
              :modal="biometria"
              :tipoBiometria="'cadastro'"
              :userId="filtro.responsavelId"
              @atualizarBiometrias="atualizarTemplatesBiometria"
            />
          </div>
        </div>
        <div class="row col-12" v-if="filtro.tipoAutenticacao === 'assinatura'">
          <Canvas @update="receberAssinatura" :go="salvarAssinatura" />
        </div>
        <div
          class="row col-12 items-center q-ml-md"
          v-if="filtro.tipoAutenticacao == 'web_pin'"
        >
          <q-icon class="q-mr-sm" name="lock" size="37px" />
          <q-input type="password" dense outlined v-model="pin" />
        </div>
      </div>
      <div class="row q-gutter-sm col-12 justify-end q-mt-lg">
        <div v-if="autenticacao">
          <p></p>
          <q-btn
            class="q-mt-sm"
            icon="close"
            color="negative"
            label="Cancelar"
            no-caps
            @click="autenticacao = false"
          />
        </div>
        <div v-if="!autenticacao">
          <p></p>
          <q-btn
            class="q-mt-sm"
            icon="add_circle_outline"
            color="positive"
            label="Criar Retirada"
            type="submit"
            no-caps
            @click="criarRetirada()"
          />
        </div>
        <div v-else>
          <p></p>
          <q-btn
            class="q-mt-sm"
            icon="check_circle_outline"
            color="positive"
            label="Finalizar Retirada"
            type="submit"
            no-caps
            :disable="disable"
            @click="verificarTipoAutenticacao()"
          />
        </div>
      </div>
    </div>
  </q-page>
</template>

<script>
import { ref, watch, computed, onMounted } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import SelectComponentResponsaveis from "../components/SelectComponentResponsaveis.vue";
import SelecaoFuncionario from "../../ferramentaria/components/SelecaoFuncionario.vue";
import { v4 as uuidv4 } from "uuid";
import SelectComponentGrupos from "../components/SelectComponentGrupos.vue";
import SelectComponentSubGrupos from "../components/SelectComponentSubGrupos.vue";
import VerificacaoFacial from "../../requisicao/components/VerificacaoFacial.vue";
import BiometriaModal from "../../biometria/views/Biometria.vue";
import ListaUnidadesSelect from "../../organizacional/unidade/component/ListaUnidadesSelect.vue";
import Canvas from "../components/Canvas.vue";
import PageHeader from "../../../components/PageHeader.vue";
export default {
  name: "RetirarFerramentas",
  components: {
    SelectComponentResponsaveis,
    SelecaoFuncionario,
    BiometriaModal,
    ListaUnidadesSelect,
    Canvas,
    SelectComponentGrupos,
    SelectComponentSubGrupos,
    VerificacaoFacial,
    PageHeader,
  },
  setup() {
    const store = useStore();
    const facial = ref(false);
    let myuuid = uuidv4();
    const $q = useQuasar();
    let disable = ref(true);
    let loading = ref(false);
    let semDados = ref(false);
    const filter = ref("");
    let hideBottom = ref(true);
    const ferramentasAdicionadas = ref([]);
    let recebeUnidade = ref({
      unidade: store.state.org.unidadeData.nome,
      id: store.state.org.unidadeData.id,
    });
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 6,
      rowsNumber: 6,
    });
    const selected = ref([]);
    const usuarioVerificado = ref(false);

    const filtro = ref({
      unidadeId: "",
      nome: "",
      patrimonio: "",
      fornecedorId: "",
      documento: "",
      responsavelId: "",
      responsavelNome: "",
      status: "",
      biometry: "",
      tipoAutenticacao: "",
    });

    const crachaSolicitante = ref(null);
    const usuarioEncontradoPorCracha = ref(null);

    const columns = [
      {
        name: "ferramentasselecionadas",
        label: "Selecione",
        field: "",
        align: "left",
      },
      {
        name: "codigo",
        label: "Código",
        field: "nome",
        align: "left",
        sortable: true,
      },
      {
        name: "descricao",
        label: "Descrição",
        field: "descricao",
        align: "left",
        sortable: true,
      },
      {
        name: "patrimonio",
        label: "Patrimonio",
        field: "patrimonio",
        align: "left",
        sortable: true,
      },
      {
        name: "unidade",
        label: "Unidade",
        field: "nome_unidade",
        align: "left",
        sortable: true,
      },
      {
        name: "categoria",
        label: "Grupo",
        field: "categoria_nome",
        align: "left",
        sortable: true,
      },
      {
        name: "grupo",
        label: "Sub Grupo",
        field: "grupo_nome",
        align: "left",
        sortable: true,
      },
      {
        name: "status",
        label: "Status",
        field: "status",
        align: "left",
        sortable: true,
      },
    ];
    const columns2 = [
      {
        name: "remover",
        label: "Remover",
        field: "",
        align: "left",
      },
      {
        name: "codigo",
        label: "Código",
        field: "nome",
        align: "left",
      },
      {
        name: "descricao",
        label: "Descrição",
        field: "descricao",
        align: "left",
      },
      {
        name: "patrimonio",
        label: "Patrimonio",
        field: "nome_unidade",
        align: "left",
        sortable: true,
      },
      {
        name: "unidade",
        label: "Unidade",
        field: "patrimonio",
        align: "left",
        sortable: true,
      },
      {
        name: "categoria",
        label: "Categoria",
        field: "categoria_nome",
        align: "left",
        sortable: true,
      },
      {
        name: "grupo",
        label: "Grupo",
        field: "grupo_nome",
        align: "left",
        sortable: true,
      },
      {
        name: "documentosAssociados",
        label: "Documentos",
        align: "left",
        sortable: true,
      },
      {
        name: "status",
        label: "Status",
        field: "status",
        align: "left",
        sortable: true,
      },
    ];

    const listaFerramentasDisponiveis = ref([]);
    let resetar = ref(0);
    let autenticacao = ref(false);
    let biometria = ref(false);
    const imagemBase64 = ref(null);
    const pin = ref("");
    let todasUnidades = ref(false);
    const salvarAssinatura = ref(0);
    const subGrupo = ref({
      uuid: "",
      nome: "",
      categoria_uuid: "",
      descricao: "",
    });
    const grupo = ref({ descricao: "", uuid: "", nome: "" });

    const listarFerramentasDisponiveis = async (page = 0, rowsPerPage = 30) => {
      if (filtro.value.responsavelId === "") {
        return;
      }
      loading.value = true;
      disable.value = true;
      let resposta = await store.dispatch("fer/listarFerramentas", {
        status: "Disponivel",
        unidadeId: todasUnidades.value ? "" : recebeUnidade.value.id,
        perPage: rowsPerPage,
        page,
        filtro: filter.value,
        categoria: grupo.value?.nome,
        grupo: subGrupo.value?.nome,
        patrimonio: filtro.value.patrimonio,
      });

      listaFerramentasDisponiveis.value = resposta.resposta.data.result.data;
      loading.value = false;
      disable.value = false;
      pagination.value.rowsPerPage = resposta.resposta.data.result.per_page;
      pagination.value.rowsNumber = resposta.resposta.data.result.total;

      if (listaFerramentasDisponiveis.value == "") {
        hideBottom.value = false;
        semDados.value = true;
        return;
      }
      return;
    };

    let receberDadosFuncionario = async (value) => {
      if (value === "") {
        return;
      }
      filtro.value.responsavelId = value.id;
      filtro.value.responsavelNome = value.nome;
      filtro.value.biometry = value.biometry;

      listarFerramentasDisponiveis();
    };

    const receberFuncionarioPorCracha = (value) => {
      if (value === "") {
        return;
      }
      filtro.value.responsavelId = value.id;
      filtro.value.responsavelNome = value.nome;
      filtro.value.biometry = value.biometry;

      listarFerramentasDisponiveis();
    };

    const buscarPorCracha = async (card_id) => {
      if (!card_id || card_id.trim() === "") {
        usuarioEncontradoPorCracha.value = null;
        return;
      }

      try {
        const response = await store.dispatch("fer/listarFuncionarios", {
          card_id: card_id,
          vendor_id: recebeUnidade.value?.id,
        });

        if (response.data?.results?.data?.length > 0) {
          const usuario = response.data.results.data[0];
          usuarioEncontradoPorCracha.value = usuario;

          const funcionarioFormatado = {
            id: usuario.sap,
            idTabela: usuario.id,
            nome: usuario.name,
            matricula: usuario.sap,
            centroCustoCode: usuario.cost_center?.code,
            centroCustoName: usuario.cost_center?.name,
            biometria: usuario.biometry,
          };

          receberFuncionarioPorCracha(funcionarioFormatado);
        } else {
          usuarioEncontradoPorCracha.value = null;
        }
      } catch (error) {
        console.error("Erro ao buscar usuário por crachá:", error);
        usuarioEncontradoPorCracha.value = null;
      }
    };

    const temPermissaoCracha = () => {
      return (
        store.state.autenticacao?.usuarioLogado?.permissoes?.gmapi?.roles?.includes(
          "voucher-auth-cracha"
        ) || false
      );
    };

    const removerFerramenta = async (uuid) => {
      selected.value = selected.value.filter(
        (ferramenta) => ferramenta.uuid != uuid
      );
    };

    const retirarFerramentas = async () => {
      if (filtro.value.tipoAutenticacao === "") {
        $q.notify({
          message: "Escolha um método de autenticação.",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      if (
        (imagemBase64.value == null &&
          filtro.value.tipoAutenticacao == "biometria") ||
        (imagemBase64.value == null &&
          filtro.value.tipoAutenticacao == "assinatura")
      ) {
        $q.notify({
          message: "Realize a autenticação para a fazer a retirada dos itens.",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      if (
        !usuarioVerificado.value &&
        filtro.value.tipoAutenticacao === "biometria"
      ) {
        $q.notify({
          message: "A Biometria coletada não coincide com a do requisitante",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      try {
        $q.notify({
          message: "Processando retirada.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        disable.value = true;
        await store.dispatch("fer/retirarFerramenta", {
          responsavelId: filtro.value.responsavelId,
          ferramentas: selected.value,
          uuid: myuuid,
          dh_retirada: gerarTimestamp(),
          biometria: imagemBase64.value,
        });
        $q.notify({
          message: "O itens foram retirados com sucesso!.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        resetarVariaveis();
        disable.value = false;
      } catch (error) {
        disable.value = false;
        if (error.request.status < 500) {
          for (let index in error.response.data.errors) {
            $q.notify({
              message: error.response.data.errors[index],
              color: "negative",
              actions: [
                {
                  label: "Fechar",
                  color: "white",
                  handler: () => {
                    /* ... */
                  },
                },
              ],
            });
          }
        }

        if (error.request.status >= 500) {
          $q.notify({
            message: "Erro no servidor, tente novamente",
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
      }
    };

    const criarRetirada = () => {
      if (selected.value.length == 0) {
        $q.notify({
          message: "Adicione uma ou mais itens para retirar!",
          color: "negative",
          position: "top",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      if (filtro.value.responsavelId == "") {
        $q.notify({
          message: "Selecione um responsável para retirar.",
          color: "negative",
          position: "top",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      $q.notify({
        message: "Retirada criada, faça a autenticação para finalizar!",
        color: "positive",
        actions: [
          {
            label: "fechar",
            color: "white",
            handler: () => {
              /* ... */
            },
          },
        ],
      });
      autenticacao.value = true;
    };

    const atualizarTemplatesBiometria = async () => {
      try {
        await store.dispatch("user/atualizarTemplatesBiometria");
        listarUsuarios();
      } catch (error) {
        console.log(error);
      }
    };

    const listarUsuarios = async () => {
      try {
        const response = await store.dispatch("requisicao/listarSolicitante", {
          per_page: 10,
          vendor_id: recebeUnidade.value.id,
          search: filtro.value.responsavelNome,
        });
        if (autenticacao.value) {
          let array = response.data.results.data.value.filter((user) => {
            return filtro.value.responsavelId == user.id;
          });
          filtro.value.biometry = array[0].biometry;
        }
      } catch (error) {
        console.log(error);
      }
    };

    const recebeBiometria = async (value) => {
      imagemBase64.value = value;
    };

    const receberAssinatura = async (value) => {
      if (value == undefined || value == null) {
        $q.notify({
          message: "Assine para finalizar a retirada.",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      imagemBase64.value = value.split("base64,")[1];
      retirarFerramentas();
    };

    const resetarVariaveis = () => {
      listaFerramentasDisponiveis.value = [];
      filtro.value.responsavelId = "";
      filtro.value.responsavelNome = "";
      resetar.value++;
      filtro.value.tipoAutenticacao = "";
      filtro.value.patrimonio = "";
      selected.value = [];
      autenticacao.value = false;
      usuarioVerificado.value = false;
      imagemBase64.value = null;
      pin.value = "";
      subGrupo.value = {
        uuid: "",
        nome: "",
        categoria_uuid: "",
        descricao: "",
      };
      grupo.value = { descricao: "", uuid: "", nome: "" };
      filter.value = "";
    };

    const checarPin = async () => {
      if (pin.value == "") {
        $q.notify({
          message: "O campo não pode estar vazio",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      try {
        const response = await store.dispatch("requisicao/checarPin", {
          pin: pin.value,
          user_id: filtro.value.responsavelId,
        });
        if (response.data.result.pin_correto) {
          $q.notify({
            message:
              "Senha Validada com Sucesso, a retirada de itens será finalizada!",
            color: "positive",
            actions: [
              {
                label: "fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          usuarioVerificado.value = true;
          imagemBase64.value = null;
          retirarFerramentas();
        } else {
          $q.notify({
            message: "PIN digitado, não corresponde ao pin do usuário!",
            color: "negative",
            actions: [
              {
                label: "fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
      } catch (error) {
        $q.notify({
          message: "Erro ao validar pin",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const receberResultadoBiometria = (value) => {
      usuarioVerificado.value = value;
    };

    const verificarDocumentosAssociados = async (ferramentaUuid) => {
      try {
        const response = await store.dispatch("fer/listarDocumentosCriados", {
          unidadeId: recebeUnidade.value.id,
          perPage: 100,
          vinculadoId: ferramentaUuid,
          origemVinculo: "ferramenta",
        });
        if (response.data.resultado.dados.length > 0) {
          adicionarDocumentosAssociadosFerramenta(
            ferramentaUuid,
            response.data.resultado.dados
          );
          return;
        }
      } catch (error) {
        console.log(error);
      }
    };

    const adicionarDocumentosAssociadosFerramenta = (
      ferramentaUuid,
      documentos
    ) => {
      let vencidoAtivo = false;
      documentos.some((doc) => {
        if (doc.status == "vencido") {
          vencidoAtivo = true;
        }
      });
      if (selected.value.length == 0) {
        return;
      }
      selected.value.some((ferramenta) => {
        if (ferramenta.uuid == ferramentaUuid) {
          ferramenta.documentosAssociados = documentos;
          ferramenta.vencidoAtivo = vencidoAtivo;
        }
      });
    };

    const verificarTipoAutenticacao = () => {
      if (filtro.value.tipoAutenticacao == "web_pin") {
        checarPin();
        return;
      }
      if (filtro.value.tipoAutenticacao == "assinatura") {
        salvarAssinatura.value++;
        return;
      }
      if (filtro.value.tipoAutenticacao == "biometria") {
        retirarFerramentas();
        return;
      }
      retirarFerramentas();
    };

    const receberDadosGrupo = async (value) => {
      if (value === "") {
        subGrupo.value = {
          uuid: "",
          nome: "",
          categoria_uuid: "",
          descricao: "",
        };
        grupo.value = { descricao: "", uuid: "", nome: "" };
        return;
      }
      grupo.value = value;
    };

    const receberDadosSubGrupo = async (value) => {
      if (value === "") {
        subGrupo.value = {
          uuid: "",
          nome: "",
          categoria_uuid: "",
          descricao: "",
        };
        return;
      }
      subGrupo.value = value;
    };

    const gerarTimestamp = () => {
      let dataAtual = new Date();

      let ano = dataAtual.getFullYear();
      let mes = (dataAtual.getMonth() + 1).toString().padStart(2, "0");
      let dia = dataAtual.getDate().toString().padStart(2, "0");
      let horas = dataAtual.getHours().toString().padStart(2, "0");
      let minutos = dataAtual.getMinutes().toString().padStart(2, "0");
      let segundos = dataAtual.getSeconds().toString().padStart(2, "0");

      return `${ano}-${mes}-${dia} ${horas}:${minutos}:${segundos}`;
    };

    watch(
      () => store.state.org.unidadeData.id,
      () => {
        if (store.state.org.unidadeData == null) {
          return;
        }
        recebeUnidade.value.unidade = store.state.org.unidadeData;
        recebeUnidade.value.id = store.state.org.unidadeData.id;
        listarFerramentasDisponiveis(
          pagination.value.page,
          pagination.value.rowsPerPage
        );
        selected.value = [];
        listaFerramentasDisponiveis.value = [];
        autenticacao.value = false;
        usuarioVerificado.value = false;
        imagemBase64.value = null;
        pin.value = "";
      }
    );

    const getUnidade = () => {
      if (
        localStorage.unidade &&
        localStorage.unidade != null &&
        localStorage.unidade != "null"
      ) {
        let getunidade = localStorage.getItem("unidade");
        recebeUnidade.value.unidade = JSON.parse(getunidade);
      }
    };

    onMounted(getUnidade);
    watch(
      () => filter.value,
      () => {
        listarFerramentasDisponiveis();
      }
    );

    watch(
      () => filtro.value.tipoAutenticacao,
      () => {
        usuarioVerificado.value = false;
        imagemBase64.value = null;
        pin.value = "";
      }
    );

    watch(
      () => filtro.value.responsavelId,
      () => {
        selected.value = [];
        listaFerramentasDisponiveis.value = [];
        autenticacao.value = false;
        usuarioVerificado.value = false;
        imagemBase64.value = null;
        pin.value = "";
      }
    );

    watch(
      () => pagination.value.page,
      () => {
        listarFerramentasDisponiveis(
          pagination.value.page,
          pagination.value.rowsPerPage
        );
      }
    );

    watch(
      () => todasUnidades.value,
      () => {
        listarFerramentasDisponiveis(
          pagination.value.page,
          pagination.value.rowsPerPage
        );
      }
    );

    watch(
      () => grupo.value,
      () => {
        if (filtro.value.responsavelId != "") {
          listarFerramentasDisponiveis(
            pagination.value.page,
            pagination.value.rowsPerPage
          );
        }
      }
    );

    watch(
      () => subGrupo.value,
      () => {
        if (filtro.value.responsavelId != "") {
          listarFerramentasDisponiveis(
            pagination.value.page,
            pagination.value.rowsPerPage
          );
        }
      }
    );

    watch(
      () => filtro.value.patrimonio,
      () => {
        if (filtro.value.responsavelId != "") {
          listarFerramentasDisponiveis(
            pagination.value.page,
            pagination.value.rowsPerPage
          );
        }
      }
    );

    const fecharFacial = async () => {
      facial.value = false;
    };

    const receberFace = async (faceImage) => {
      imagemBase64.value = faceImage;
      facial.value = false;

      $q.notify({
        message: "Face recebida com sucesso",
        color: "positive",
        actions: [
          {
            label: "fechar",
            color: "white",
            handler: () => {
              /* ... */
            },
          },
        ],
      });
    };

    return {
      fecharFacial,
      receberFace,
      facial,
      filter,
      filtro,
      receberDadosFuncionario,
      receberFuncionarioPorCracha,
      buscarPorCracha,
      temPermissaoCracha,
      crachaSolicitante,
      usuarioEncontradoPorCracha,
      columns,
      listaFerramentasDisponiveis,
      listarFerramentasDisponiveis,
      retirarFerramentas,
      myuuid,
      columns2,
      ferramentasAdicionadas,
      removerFerramenta,
      recebeUnidade,
      disable,
      loading,
      semDados,
      getUnidade,
      hideBottom,
      pagination,
      autenticacao,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      selected,
      resetar,
      resetarVariaveis,
      criarRetirada,
      usuarioVerificado,
      biometria,
      atualizarTemplatesBiometria,
      recebeBiometria,
      imagemBase64,
      pin,
      checarPin,
      receberResultadoBiometria,
      verificarDocumentosAssociados,
      todasUnidades,
      receberAssinatura,
      salvarAssinatura,
      verificarTipoAutenticacao,
      receberDadosGrupo,
      subGrupo,
      grupo,
      receberDadosSubGrupo,
      gerarTimestamp,
    };
  },
};
</script>
<style scoped>
a {
  text-decoration: none;
}
tbody tr td {
  white-space: pre-wrap;
}
.elipse {
  width: 12px;
  height: 12px;
  border-radius: 50%;
}
.elipse-table {
  width: 12px;
  height: 12px;
  border-radius: 50%;
}
.q-table__top,
thead tr:first-child th {
  background-color: #eef3fe;
}

thead tr th {
  position: sticky;
  z-index: 1;
}
thead tr:first-child th {
  top: 0;
}

.q-table--loading thead tr:last-child th {
  top: 48px;
}
.my-sticky-dynamic {
  max-height: 450px;
}
thead tr th {
  position: sticky;
  z-index: 1;
}
thead tr:last-child th {
  top: 48px;
}
thead tr:first-child th {
  top: 0;
}
.imagem-biometria {
  height: 80px;
  width: 80px;
  cursor: pointer;
}
</style>
